export const MAIL_TEMPLATE = {
  FINISH: "MRRF",
  REJECT: "MRRR",
  APPROVE: "MRRA",
};
